// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"component-divider-horizontal"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M8 18L8 6L3 6L3 18H8Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M21 18V6L16 6L16 18H21Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M8 18L8 6L3 6L3 18H8Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M21 18V6L16 6L16 18H21Z","stroke-width":2},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 3L12 21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-component-divider-horizontal')
export default class ComponentDividerHorizontalIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'component-divider-horizontal',
    }
  }
}
